import { defineStore } from 'pinia'

export const useDesktopIconsStore = defineStore('desktopIcons', {
  state: () => ({
    iconPositions: JSON.parse(localStorage.getItem('desktopIconPositions')) || {}
  }),
  actions: {
    saveIconPosition(iconId, position) {
      this.iconPositions[iconId] = position
      localStorage.setItem('desktopIconPositions', JSON.stringify(this.iconPositions))
    },
    getIconPosition(iconId) {
      return this.iconPositions[iconId] || null
    },
    loadState() {
      this.iconPositions = JSON.parse(localStorage.getItem('desktopIconPositions')) || {}
    }
  }
})
